export default __webpack_public_path__ + "static/media/linkedIn.cb525c53.svg";